module.exports = __webpack_public_path__ + "static/media/chat03-2.0312e3fc.svg";